import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class PasswordValidator {
    /**
     * check ob beide Felder den selben Inhalt haben
     */
    public static areEqual(pw1: string, pw2: string): ValidatorFn {
        return (group: AbstractControl): ValidationErrors | null => {
            const password1 = group.get(pw1)?.value;
            const password2 = group.get(pw2)?.value;

            const areEqual = password1 === password2;

            return areEqual ? null : { passwordValidator: true };
        }
    }
}
